// Something collected is something to deliver. Waiting for minRows meant that a job whose minimum
// equals its maximum only ever opened the Delivery tab on a complete set: stop at 2 of 24 and there
// was no way to hand those 2 in. A job asking for no entries stays deliverable, as it was.
//
// Its own module so it can be unit tested: the two components that gate on it import
// react-router-dom, which CRA's jest resolver cannot load.
export default function canDeliver(progress) {
	return progress.done > 0 || progress.minRows === 0;
}
